import React from 'react';
import { Table } from 'antd';

import { buildResponsiveColumns, buildResponsiveData } from '../util';
import { useWindowSize } from '../../../../hooks/useWindowSize';
import { ColumnProps, TableProps, TablePaginationConfig } from 'antd/es/table';

import { ItemFormat } from '../types';

interface Props extends TableProps<any> {
    loading: boolean;
    columns: ColumnProps<any>[];
    data: any[];
    emptyTable: any;
    columnsFormat?: ItemFormat[];
    // onRow?: (record: any, index: number) => unknown;
    pagination?: TablePaginationConfig | false;
    onChange?: (pagination: TablePaginationConfig, filters: any, sorter: any, extra: any) => void;
}

const CustomResponsiveTable: React.FC<Props> = ({
    loading,
    columns,
    data,
    emptyTable,
    columnsFormat,
    pagination,
    onRow,
    onChange,
    ...rest
}) => {
    const { width } = useWindowSize();

    const isMobile = false;
    const columnsSource = buildResponsiveColumns(isMobile, columns);
    const dataSource = buildResponsiveData(isMobile, data, columns, columnsFormat);

    return (
        <Table
            className="records-list"
            columns={columnsSource}
            rowKey={(record: any) => record.id.toString()}
            loading={loading}
            dataSource={dataSource}
            locale={{ emptyText: typeof emptyTable === 'function' ? emptyTable() : emptyTable }}
            pagination={pagination}
            onRow={onRow}
            onChange={onChange}
            scroll={width || window.innerWidth <= 1160 ? { x: 1160 } : { x: true }}
            {...rest}
            tableLayout="fixed"
        />
    );
};

export default CustomResponsiveTable;
